<template>
  <div class="contact-us-pg tc">
    <h2>{{ ContactNoLabel }}</h2>
    <h2 class="prim-ui">{{ ContactNo }}</h2>
    <h2>{{ ContactEmailLabel }}</h2>
    <h2 class="prim-ui">{{ ContactEmail }}</h2>
  </div>
</template>

<script>
export default {
  name: "ContactDetails",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {},
  computed: {
    ContactNoLabel() {
      return this.modulePropsData?.ContactNoLabel;
    },
    ContactEmailLabel() {
      return this.modulePropsData?.ContactEmailLabel;
    },
    ContactNo() {
      return this.modulePropsData?.ContactNo;
    },
    ContactEmail() {
      return this.modulePropsData?.ContactEmail;
    },
  },
};
</script>
